"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    titleText: {
        color: function (data) { return data.color; },
    },
};
//# sourceMappingURL=title.theme.js.map